// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2XceV","tab":"ProcedureTabs_tab__2JU52"};